export default __webpack_public_path__ + "static/img/sc2.2bf43a4.png";